import { colors, getTypographyFontStyle } from "../../styles/global.style";
import styled from "styled-components";

const CustomInput = styled.input`
  background: ${colors.light};
  border-radius: 12px;
  border: 2px solid transparent;
  padding: 16px 20px;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.25s ease;
  ${getTypographyFontStyle({ variant: "body2", weight: 400 })};
  color: ${colors.secondary};

  &::placeholder {
    color: ${colors.darkGrey}80;
  }

  &:hover {
    background: ${colors.white};
    border-color: ${colors.border};
  }

  &:focus {
    background: ${colors.white};
    border-color: ${colors.primary};
    outline: none;
    box-shadow: 0 0 0 4px ${colors.primary}15;
  }

  ${(props) =>
    props.$isError && `
    border-color: ${colors.danger};
    background: ${colors.white};

    &:focus {
      border-color: ${colors.danger};
      box-shadow: 0 0 0 4px ${colors.danger}15;
    }
  `}
`;

const InputLabel = styled.label`
  display: block;
  color: ${colors.secondary};
  ${getTypographyFontStyle({ variant: "body2", weight: 500 })};
  margin-bottom: 8px;

  .required {
    color: ${colors.primary};
    margin-left: 4px;
  }
`;

const InputFieldContainer = styled.div`
  width: 100%;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export { CustomInput, InputFieldContainer, InputLabel, InputWrapper };
